import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary, PromptConfirmationModal } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { getBackRoute } from '../route';
import { ExternalUrlActionType, ExternalUrlStickyHeaderProps } from '../types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './external-url-sticky-header.scss';

export const ExternalUrlStickyHeader: React.FC<ExternalUrlStickyHeaderProps> = ({
  actionType, shouldPrompt, externalUrlItem, name, fetching, translation, onSave, onDelete
}) => {

  const updatingItem = isDefinedIncludingZero(externalUrlItem?.id);
  const onCancel = () => {
    navigate.to({ pathname: getBackRoute() });
  };

  return <StickyHeader
      className={styles.header}
      rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary
            id="external-url-form-sticky-header-cancel-button"
            onClick={onCancel}>
            {translation.cancel}
          </ButtonTertiary>
          <ButtonCallToAction
            id="external-url-form-sticky-header-save-button"
            onClick={onSave}
            disabled={!shouldPrompt}>
            {translation.save}
          </ButtonCallToAction>
        </StickyHeaderButtonContainer>
        {actionType === ExternalUrlActionType.edit && externalUrlItem.id !== 0
          ? <MeatballMenu id="external-url-form-sticky-header-meatballmenu">
            <li>
              <PromptConfirmationModal
                title={translation.delete_external_url_title}
                description={replaceTemplateString(
                  translation.delete_confirmation,
                  name)}
                continueText={translation.delete_external_url_button}
                cancelText={translation.cancel}
                onContinue={onDelete}>
                <button type="button" className="dropdown-item" disabled={fetching}>
                  {translation.delete_external_url_button}
                </button>
              </PromptConfirmationModal>
            </li>
          </MeatballMenu> : null}
      </>} >
      <div className={styles.headerContainer}>
        {updatingItem ? <span className={styles.headerId}>
          #{externalUrlItem.id}
        </span> : null}
        <h2 className={styles.headerTitle}>
          {updatingItem
            ? name || null
            : translation.new_external_url}
        </h2>
        {isDisabled(externalUrlItem.disabled) ? <Tag>{translation.disabled}</Tag> : null}
      </div>
    </StickyHeader>;
};
